var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snaliens landing-page"},[_c('div',{staticClass:"artwork"},[_c('div',{staticClass:"title"}),_c('heads'),_c('tree',{staticClass:"tree t1"}),_c('tree',{staticClass:"tree t2"})],1),_c('div',{staticClass:"bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }